  <div class="questionnaire-container">
    <true-breadcrumbs [subset]="this.config.subset" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>
    <!-- Business brief Section -->
    <!-- TODO: replace image with interactive document - scroll to view, click to download? -->    
    <div class="questionnaire-layout">
      <div class="questionnaire-image">
        <img src="assets/trl-td.png" alt="trl" />
      </div>
      <div class="questionnaire-instructions">
        <h2>TRL Assessment Overview</h2>
        <p>
            The TRL Assessment evaluates the technology readiness levels of your business components. It provides insights into the maturity of technologies used in your operations.
        </p>
        <h2>Technology Maturity Evaluation</h2>
        <p>
            This component helps identify the current TRL of each technology, guiding you in understanding the development stage and necessary steps to advance to higher levels.
        </p>
        <h2>Strategic Planning and Development</h2>
        <p>
            By assessing TRLs, you can strategically plan technology development, allocate resources effectively, and mitigate risks associated with technological implementation.
        </p>
      </div>
    </div>    

    <!--<div class="questionnaire-section-header">      
      <mat-form-field class="questionnaire-section-dropdown" appearance="fill">
        <mat-label>Select Section</mat-label>
        <mat-select [(value)]="selectedSection" (selectionChange)="onSectionChange($event.value)">
          <mat-option *ngFor="let section of sections" [value]="section">
            {{ section.questionTitle }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>-->
    
    <ng-template [ngIf]="selectedSection">
      <div class="questionnaire-flex-layout section-selection">
        <!-- First Column: Display Selected Section List -->
        <div class="questionnaire-column">
          <div class="header-with-actions">
            <h2>Section selection</h2>
            <span class="spacer"></span>
            <button title="Previous section" mat-icon-button aria-label="Undo" (click)="previousSection()">
              <mat-icon>navigate_before</mat-icon>
            </button>              
            <button title="Next section" mat-icon-button aria-label="Redo" (click)="nextSection()">
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>
        </div>        
      </div>
      <h2 class="questionnaire-section-title">{{ selectedSection.questionTitle }}</h2>
      <div class="questionnaire-last-saved" [ngClass]="{'questionnaire-animation': animate}" (animationend)="onAnimationEnd()" *ngIf="lastSaveTime">
          Last saved at: {{ lastSaveTime }}
      </div>
      <div class="questionnaire-section-content">
        <div class="questionnaire-flex-layout">
          <!-- First Column: Display Selected Section List -->
          <div class="questionnaire-column">
            <div class="header-with-actions">
              <h2>Section list</h2>
              <span class="spacer"></span>
              <!--<button title="Previous section" mat-icon-button aria-label="Undo" (click)="previousSection()">
                <mat-icon>navigate_before</mat-icon>
              </button>              
              <button title="Next section" mat-icon-button aria-label="Redo" (click)="nextSection()">
                <mat-icon>navigate_next</mat-icon>
              </button>-->
            </div>            
            <mat-nav-list>
              <mat-list-item *ngFor="let section of sections"
                          (click)="selectedSection = section"
                          [class.selected]="section === selectedSection"
                          class="section-item">
              <div class="section-content">
                <div class="section-title" title="{{section.questionTitle}}">
                    {{ section.questionTitle }}
                </div>            
                <mat-icon class="status-icon"
                        [ngClass]="{
                            'completed': section.answer?.trim().toLowerCase() === 'yes',
                            'incomplete': section.answer?.trim().toLowerCase() === 'no'
                        }">
                  {{ section.answer?.trim().toLowerCase() === 'yes' ? 'check_circle' : 'radio_button_unchecked' }}
                </mat-icon>
              </div>      
              </mat-list-item>
            </mat-nav-list>            
          </div>
          <!-- Second Column: Display Selected Section Content -->
          <div class="questionnaire-column">
            <div class="header-with-actions">
              <h2>Section details</h2>
              <button style="visibility: hidden" mat-icon-button >
                <mat-icon>/</mat-icon>
              </button>
            </div>            
            <h2>TRL SELECTION QUESTION</h2>
            <p [innerHTML]="selectedSection.description"></p>
            <h2>Example</h2>
            <p [innerHTML]="selectedSection.example"></p>
          </div>
          <!-- Third Column: Answer -->
          <div class="questionnaire-column">            
            <div class="header-with-actions">
              <h2>Your answer</h2>
              <span class="spacer"></span>
              <button title="Yes" mat-icon-button aria-label="Undo" (click)="yes()">
                <mat-icon>check_circle</mat-icon>
              </button>
              <button title="No" mat-icon-button (click)="no()">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
            <p>Your answer to this section is: {{ selectedSection.answer | uppercase }}</p>
            <p *ngIf="trlLevelReached">
              Based on all the answers, you've reached TRL {{ trlLevel }} with your product or service.<br>              
            </p>
            <p>
              You can proceed to the business model evaluation section.
            </p>
          </div>
        </div>
      </div>
    </ng-template>    
  </div>